import { Component, inject, OnDestroy, OnInit, signal } from "@angular/core";
import { ToastService } from "../../services/toast.service";
import { AuthService } from "../../auth/auth.service";
import { PolicyDocumentService } from "../../services/policyDocument.service";
import { Subscription } from "rxjs";
import { jsPDF } from 'jspdf';
import { ToastType } from "../../enums/config.enum";
import { SpinnerComponent } from "../utils/spinner/spinner.component";
import { Aul10424Component } from "../quote-documents/aul-104-24/aul-104-24.component";

@Component({
    selector: "app-endorsement-document",
    standalone: true,
    imports: [SpinnerComponent, Aul10424Component],
    templateUrl: './endorsement-document.component.html',
    styleUrl: './endorsement-document.component.scss'
})
export class EndorsementDocument implements OnInit, OnDestroy{
    isGeneratingPDF = signal(false);
    toastService = inject(ToastService);
    authService = inject(AuthService);
    endorsementDocumentService = inject(PolicyDocumentService);
    endorsementDetails = signal<any>('');
    endorsementDocumentSubs = new Subscription();
    endorsementNo = signal('');
    pdf: any = '';

    ngOnInit(): void {
      this.endorsementDocumentSubs = this.endorsementDocumentService.getDownloadEndorsementDocument().subscribe({
          next: (response: boolean) => {
            if(response){
              this.getEndorsementDocumentDetails();
              this.endorsementDocumentService.setDownloadEndorsementDocument(false); // reset the policy document download trigger
            }
          }
      });
    }

    getEndorsementDocumentDetails() {
        this.endorsementDocumentService.onDownloadEndorsementDocument(Number(this.authService.getUserDetailsFromStorage()?.policyId))
        .subscribe({
          next: (response: any) => {
            if(response){
              this.toastService.addNotification({message: "Document generation Inprogress", type: ToastType.Info});
              // API response shape can vary:
              // - { result: [ { aul10424: {...} } ] }
              // - [ { aul10424: {...} } ]
              // Normalize so the template always receives the first record object.
              const payload =
                Array.isArray(response?.result) ? response.result :
                Array.isArray(response) ? response :
                Array.isArray(response?.data) ? response.data :
                [];

              const firstRecord = Array.isArray(payload) && payload.length > 0 ? payload[0] : null;
              this.endorsementDetails.set(firstRecord); // bind the data

              const endorsementNumber = firstRecord?.aul10424?.endorsementNumber;
              if (endorsementNumber) {
                this.endorsementNo.set(endorsementNumber);
              }
              setTimeout(() => {
                this.generatePDF(); // generate the pdf
              }, 0)
            }
          },
          error: (error: any) => {
            console.log("error", error);
            this.toastService.addNotification({message: "System error. Failed to retrieve data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
          }
        });
    }

    async generatePDFNew(): Promise<void> {
        this.isGeneratingPDF.set(true);
        let pdf = new jsPDF("l", "pt", "a4", true);

        const pages: any = document.getElementById('endorsement-pdf-pages')?.innerHTML;
        let pdfEndorsementNo = this.endorsementNo();
        const self = this;
        pdf.html(pages, {
        callback: function(doc) {
        self.isGeneratingPDF.set(true);
            const totalPages = doc.getNumberOfPages();
            for (let pageNumber = 1; pageNumber <= totalPages; pageNumber++) {
            doc.setPage(pageNumber);
            doc.setFontSize(8);
            doc.setTextColor("black");
            doc.text(`Page: ${pageNumber}/${totalPages}`, 10, doc.internal.pageSize.height - 5);
            }
            self.isGeneratingPDF.set(false);
            pdf.save("Endorsement Document_" + pdfEndorsementNo + ".pdf");
            self.toastService.addNotification({message: "Document generation Completed", type: ToastType.Success});
        },
        html2canvas: {
            scale: 0.9,
            logging: false,
            windowWidth: 910 // 816 = letter paper pixel width at 96dpi (web), 786 = less the 30px margin
        },
        x: 0,
        y: 0,
        margin: [15, 10, 15, 10], // mm
        width: 910, // 216 = letter paper width in mm, 208 = less the 8mm margin
        windowWidth: 910,  // 816 = letter paper pixel width at 96dpi (web), 786 = less the 30px margin
    
        });
    }
    
    async generatePDF(): Promise<void> {
        this.isGeneratingPDF.set(true);
        let pdf = new jsPDF("p", "pt", "a4", true);
        let pageHeight = pdf.internal.pageSize.getHeight();
        let pageWidth = pdf.internal.pageSize.width;

        const pages = document.querySelectorAll('.endorsement-pdf-page')
        for(let i=0; i<pages.length; i++){
            let numberOfPages = pdf.getNumberOfPages();
            
            await pdf.html(pages[i] as HTMLElement, {
            callback: function (pdf2: any) {
                pdf2.setPage(i+1);
                pdf2.setFontSize(8);
                pdf2.setTextColor("black");
                pdf2.text(`Page: ${i+1}/${pages.length}`, 10, pdf2.internal.pageSize.height - 5);
                return pdf2
            },
            y: i ? (numberOfPages * pageHeight) + 20: 20,
            autoPaging: 'text',
            x: 20,
            width: pageWidth - 40 ,
            windowWidth: 800,
            });
        };

        this.isGeneratingPDF.set(false);
        pdf.save("Endorsement Document_" + this.endorsementNo() + ".pdf");
        
        this.toastService.addNotification({message: "Document generation Completed", type: ToastType.Success});
    }

    ngOnDestroy(): void {
        this.endorsementDocumentSubs?.unsubscribe();
    }
}